import groq from 'groq';

import { ASSET } from './asset';
import { CAPTIONS_VIDEO } from './captionsVideo';
import { CLOUDINARY_VIDEO } from './cloudinaryVideo';

export const VIDEO_CARD = groq`
  title,
  subtitle,
  "thumbnail": thumbnail[0]{
    _type,
    _type == 'altImage' => {
      ${ASSET}
    },
    _type == 'gif' => {
      ${CLOUDINARY_VIDEO},
      poster { ${ASSET} }
    }
  },
  video {
    ${CAPTIONS_VIDEO}
  }
`;
